<script lang="ts">
  import Footer from '../components/Footer.svelte'
  import CompanyHero from './components/CompanyHero.svelte'
  import JoinTeam from './components/JoinTeam.svelte'
  import Team from './components/Team.svelte'
  import ValuedPartners from './components/ValuedPartners.svelte'
  import Values from './components/Values.svelte'
</script>

<div class="fade-in relative z-[1] space-y-24 overflow-hidden sm-desktop:space-y-52 lg-desktop:space-y-64">
  <CompanyHero />
  <Team />
  <Values />
  <ValuedPartners />
  <JoinTeam />
  <Footer nextPage="Contact" pageLink="/contact" />
</div>
